import { render, staticRenderFns } from "./GarageList.vue?vue&type=template&id=5b7d5a79&scoped=true&"
import script from "./GarageList.vue?vue&type=script&lang=js&"
export * from "./GarageList.vue?vue&type=script&lang=js&"
import style0 from "./GarageList.vue?vue&type=style&index=0&id=5b7d5a79&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b7d5a79",
  null
  
)

export default component.exports